module.exports = __webpack_public_path__ + "img/arrow.e5b42354.png";